import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {PromotedSponsorshipModuleConfig} from "./promoted-sponsorship-module.config";
import {PromotedSponsorshipModuleStore} from "./promoted-sponsorship-module.store";
import {PromotedSponsorshipModuleHandlers} from "./handlers/promoted-sponsorship-module.handlers";

export class PromotedSponsorshipModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables,  PromotedSponsorshipModuleConfig, PromotedSponsorshipModuleStore, PromotedSponsorshipModuleHandlers];

}
